import styled from 'styled-components'

export  const MainMessageWrapper = styled.section`
 text-align:center;
 font-size:14px;
 line-height:2;

 background-color:#fff;
 box-sizing:border-box;
 font-weight:bold;
 color:#000;
 font-family: 'Noto Serif JP', serif;
  
 @media(min-width:651px) {
  padding:80px 0 80px 0;
  p{
    font-size:18px;
    line-height:2.7;
  }
 }

`